export default {
  path: '/',
  component: () => import('@/components/Layout/index.vue'),
  children: [
    {
      path: '/home',
      name: 'Home',
      meta: {
        needLogin: true,
        isKeepAlive: true,
        key: Date.now(),
        title: 'Home', // t('route.HOME')
        keepScroll: true, // 标识需要记录滚动位置
        scrollTop: 0, // 存储滚动位置
      },
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/rewardCenter',
      name: 'RewardCenter', // t('route.RewardCenter')
      meta: {
        needLogin: true,
        title: 'Reward Center',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/rewardCenter/index.vue'),
    },
    {
      // 创作者个人中心
      path: '/:domain',
      name: 'Creators', //  t('route.Creators')
      meta: {
        needLogin: false,
        isKeepAlive: false,
        key: Date.now(),
      },
      component: () => import('@/views/creators/index.vue'),
    },
    {
      path: '/settings',
      name: 'Settings', // t('route.EditProfile')
      meta: {
        needLogin: true,
        title: 'Edit Profile',
      },
      component: () => import('@/views/settings/index.vue'),
      children: [
        {
          path: 'profile',
          name: 'EditProfile',
          meta: { needLogin: true, title: 'profile' },
          component: () => import('@/views/settings/profile.vue'),
        },
        // Account
        {
          path: 'account',
          name: 'Account',
          meta: { needLogin: true, title: 'account' },
          component: () => import('@/views/settings/account/index.vue'),
        },
        // Account: Change Email
        {
          path: 'account/email',
          name: 'ChangeEmail',
          meta: { needLogin: true, title: 'Change email' },
          component: () => import('@/views/settings/account/changeEmail.vue'),
        },
        // Account: Verify Email
        {
          path: 'account/verifyEmail',
          name: 'VerifyEmail',
          meta: { needLogin: true, title: 'Verify email' },
          component: () => import('@/views/settings/account/verifyEmail.vue'),
        },
        // Account: Bind Email
        {
          path: 'account/bindEmail',
          name: 'BindEmail',
          meta: { needLogin: true, title: 'Bind email' },
          component: () => import('@/views/settings/account/bindEmail.vue'),
        },
        // Account: Change Password
        {
          path: 'account/password',
          name: 'ChangePassword',
          meta: { needLogin: true, title: 'Change password' },
          component: () => import('@/views/settings/account/changePassword.vue'),
        },
        // Account: Full Name
        {
          path: 'account/fullName',
          name: 'FullName',
          meta: { needLogin: true, title: 'Full name' },
          component: () => import('@/views/settings/account/fullName.vue'),
        },
        // Account: Set Address
        {
          path: 'account/address',
          name: 'SetAddress',
          meta: { needLogin: true, title: 'Set address' },
          component: () => import('@/views/settings/account/setAddress.vue'),
        },
        // Account: Delete account
        {
          path: 'account/deleteAccount',
          name: 'DeleteAccount',
          meta: { needLogin: true, title: 'Set address' },
          component: () => import('@/views/settings/account/deleteAccount.vue'),
        },
        // Security
        {
          path: 'security',
          name: 'Security',
          meta: { needLogin: true, title: 'privacy and safety' },
          component: () => import('@/views/settings/security/index.vue'),
        },
        // Security：Sensitive Content Filter
        {
          path: 'security/filter',
          name: 'SensitiveContentFilter',
          meta: { needLogin: true, title: 'Sensitive content filter' },
          component: () => import('@/views/settings/security/filter.vue'),
        },
        // Security：Download Videos & Images
        {
          path: 'security/download',
          name: 'DownloadMedia',
          meta: { needLogin: true, title: 'Download Videos & Images' },
          component: () => import('@/views/settings/security/download.vue'),
        },
        // Security：Watermarks
        {
          path: 'security/watermarks',
          name: 'Watermarks',
          meta: { needLogin: true, title: 'Watermarks' },
          component: () => import('@/views/settings/security/watermarks.vue'),
        },
        // Security：Block by country
        {
          path: 'security/blockByCountry',
          name: 'BlockByCountry',
          meta: { needLogin: true, title: 'Block by country' },
          component: () => import('@/views/settings/security/blockByCountry.vue'),
        },
        // Security：Block by IP address
        {
          path: 'security/blockByIP',
          name: 'BlockByIPAddress',
          meta: { needLogin: true, title: 'Block by IP address' },
          component: () => import('@/views/settings/security/blockByIPAddress.vue'),
        },
        // Subscription
        {
          path: 'subscription',
          name: 'SubscriptionTiers',
          meta: { needLogin: true, title: 'subscription tiers' },
          component: () => import('@/views/settings/subscription/index.vue'),
        },
        // Subscription：Add/Edit Tier
        {
          path: 'subscription/tier',
          name: 'EditTier',
          meta: { needLogin: true, title: 'Subscription Tiers' },
          component: () => import('@/views/settings/subscription/tier.vue'),
        },
        // {
        //   path: 'bundles',
        //   name: 'SubscriptionBundles',
        //   meta: { needLogin: true, title: 'subscription bundles' },
        //   component: () => import('@/views/settings/components/bundles.vue')
        // },
        {
          path: 'settingChats',
          name: 'SettingChats',
          meta: { needLogin: true, title: 'setting chats' },
          component: () => import('@/views/settings/chats.vue'),
        },
        {
          path: 'pushNotifications',
          name: 'PushNotifications',
          meta: { needLogin: true, title: 'Push Notifications' },
          component: () => import('@/views/settings/notifications/PushNotifications.vue'),
        },
        {
          path: 'emailNotifications',
          name: 'EmailNotifications',
          meta: { needLogin: true, title: 'Email Notifications' },
          component: () => import('@/views/settings/notifications/EmailNotifications.vue'),
        },
        {
          path: 'telegramBot',
          name: 'TelegramBot',
          meta: { needLogin: true, title: 'Telegram Bot' },
          component: () => import('@/views/settings/notifications/TGNotifications.vue'),
        },
        {
          path: 'notifications',
          name: 'SettingNotifications',
          meta: { needLogin: true, title: 'notifications' },
          component: () => import('@/views/settings/notifications/index.vue'),
        },
        {
          path: 'tracking',
          name: 'Tracking',
          meta: { needLogin: true, title: 'tracking links' },
          component: () => import('@/views/settings/tracking.vue'),
        },
        // Collection
        {
          path: 'collection',
          name: 'Collection',
          meta: { needLogin: true, title: 'collection' },
          component: () => import('@/views/settings/collection/index.vue'),
        },
        // Collection：Create Collection
        {
          path: 'collection/create',
          name: 'CreateCollection',
          meta: { needLogin: true, title: 'Create Collection' },
          component: () => import('@/views/settings/collection/create.vue'),
        },
        // Collection: Edit Collection
        {
          path: 'collection/edit',
          name: 'EditCollection',
          meta: { needLogin: true, title: 'Edit Collection' },
          component: () => import('@/views/settings/collection/create.vue'),
        },
        // Payment Gateway Management
        {
          path: 'paymentGatewayManagement',
          name: 'PaymentGatewayManagement',
          meta: { needLogin: true, title: 'Payment Gateway Management' },
          component: () => import('@/views/settings/paymentGatewayManagement.vue'),
        },
      ],
    },
    {
      // 编辑个人信息：邮箱验证中转页
      path: '/settings/emailChange',
      name: 'EmailChange',
      meta: {
        needLogin: false,
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/settings/emailChange.vue'),
    },
    {
      // 编辑个人信息：重置密码中转页
      path: '/settings/restoreAccess',
      name: 'RestoreAccess',
      meta: {
        needLogin: false,
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/settings/restoreAccess.vue'),
    },
    {
      path: '/payments',
      name: 'Payments', // t('route.Payments')
      meta: {
        needLogin: true,
        title: 'My Payments',
        isKeepAlive: false,
      },
      component: () => import('@/views/payments/index.vue'),
    },
    {
      path: '/statistics',
      name: 'Statistic', // t('route.Statistic')
      meta: {
        needLogin: true,
        title: 'Statistic',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/statistic/index.vue'),
    },
    {
      path: '/dispute/:id',
      name: 'DisputeDetail', // t('DisputeDetails')
      meta: {
        needLogin: true,
        title: 'Dispute Detail',
        isKeepAlive: false,
      },
      component: () => import('@/views/disputeDetail/index.vue'),
    },
    {
      path: '/post',
      name: 'Post', // t('route.Post')
      meta: {
        needLogin: false,
        title: 'Post',
        isKeepAlive: false,
      },
      component: () => import('@/views/post/index.vue'),
    },
    {
      path: '/notifications',
      name: 'Notifications', // t('route.Notifications')
      meta: {
        needLogin: true,
        title: 'Notifications',
        isKeepAlive: false,
      },
      component: () => import('@/views/notifications/index.vue'),
    },
    {
      path: '/transaction/:id',
      name: 'TransactionDetail', // t('route.TransactionDetails')
      meta: {
        needLogin: true,
        title: 'Transaction Detail',
        isKeepAlive: false,
      },
      component: () => import('@/views/transactionDetail/index.vue'),
    },
    {
      path: '/withdraw/:hash',
      name: 'WithdrawDetail',
      meta: {
        needLogin: true,
        title: 'Withdraw Detail',
        isKeepAlive: false,
      },
      component: () => import('@/views/withdrawDetail/index.vue'),
    },
    {
      path: '/:domain/:id',
      name: 'ContractDetails',
      meta: {
        needLogin: true,
        isKeepAlive: false,
      },
      component: () => import('@/views/contractDetails/index.vue'),
    },
    {
      path: '/:domain/all',
      name: 'CollectionsAll',
      meta: {
        needLogin: true,
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/CollectionsAll/index.vue'),
    },
    {
      path: '/becomeCreator',
      name: 'BecomeCreator',
      meta: {
        needLogin: true,
        isKeepAlive: false,
      },
      component: () => import('@/views/becomeCreator/index.vue'),
    },
    // {
    //   path: '/sharesStaking',
    //   name: 'Shares',
    //   meta: {
    //     needLogin: true,
    //     title: 'DFans Shareholder',
    //     isKeepAlive: true,
    //     key: Date.now(),
    //   },
    //   component: () => import('@/views/share/index.vue'),
    // },
    // {
    //   path: '/shares-rewards',
    //   name: 'SharesRewards',
    //   meta: {
    //     needLogin: true,
    //     title: 'Share Rewards Dividends',
    //     isKeepAlive: false,
    //   },
    //   component: () => import('@/views/share/SharesRewards.vue'),
    // },
    // {
    //   path: '/shares-transaction',
    //   name: 'SharesTransaction',
    //   meta: {
    //     needLogin: true,
    //     title: 'Transaction',
    //     isKeepAlive: false,
    //   },
    //   component: () => import('@/views/share/SharesTransaction.vue'),
    // },
    {
      path: '/claim-dividends',
      name: 'ClaimDividends',
      meta: {
        needLogin: true,
        title: 'Claim staking dividends',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/ClaimDividends.vue'),
    },
    {
      path: '/claim-confirmation',
      name: 'ClaimConfirmation',
      meta: {
        needLogin: true,
        title: 'Second Confirmation',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/ClaimConfirmation.vue'),
    },
    {
      path: '/claim-success',
      name: 'ClaimSuccess',
      meta: {
        needLogin: true,
        title: '',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/ClaimSuccess.vue'),
    },
    {
      path: '/stake-DFS',
      name: 'StakeDFS',
      meta: {
        needLogin: true,
        title: 'Stake DFS',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/StakeDFS.vue'),
    },
    {
      path: '/stake-confirm',
      name: 'StakeConfirm',
      meta: {
        needLogin: true,
        title: 'Second Confirmation',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/StakeConfirm.vue'),
    },
    {
      path: '/stake-success',
      name: 'StakeSuccess',
      meta: {
        needLogin: true,
        title: '',
        isKeepAlive: false,
      },
      component: () => import('@/views/share/StakeSuccess.vue'),
    },
    {
      path: '/subscriptions',
      name: 'Subscriptions',
      meta: {
        needLogin: true,
        title: 'Subscriptions',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/subscriptions/index.vue'),
    },
    {
      path: '/collections',
      name: 'Collections',
      meta: {
        needLogin: true,
        title: 'Collections',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/collections/index.vue'),
    },
    {
      path: '/vault',
      name: 'Vault',
      meta: {
        needLogin: true,
        title: 'Vault',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/vault/index.vue'),
    },
    {
      path: '/createPost',
      name: 'CreatePost',
      meta: {
        needLogin: true,
        isKeepAlive: false,
      },
      component: () => import('@/views/createPost/index.vue'),
    },
    {
      path: '/searchPost/:domain',
      name: 'SearchPost',
      meta: {
        needLogin: true,
        isKeepAlive: false,
      },
      component: () => import('@/views/searchPost/index.vue'),
    },
    {
      path: '/queue',
      name: 'Queue',
      meta: {
        needLogin: true,
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/queue/index.vue'),
    },
    {
      path: '/contact',
      name: 'Contact',
      isKeepAlive: true,
      key: Date.now(),
      component: () => import('@/views/about/contact.vue'),
    },
    {
      path: '/wallet',
      name: 'Wallet',
      meta: {
        needLogin: true,
        title: 'My Wallet',
        isKeepAlive: false,
      },
      component: () => import('@/views/wallet/index.vue'),
    },
    {
      path: '/topUp',
      children: [
        {
          path: '/topUp',
          name: 'TopUp',
          meta: {
            needLogin: true,
            title: 'Top Up',
            isKeepAlive: true,
            key: Date.now(),
          },
          component: () => import('@/views/topUp/index.vue'),
        },
        {
          path: 'depositMethod',
          name: 'DepositMethod',
          meta: {
            needLogin: true,
            title: 'Deposit Method',
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/depositMethod.vue'),
        },
        {
          path: 'deposit',
          name: 'Deposit',
          meta: {
            needLogin: true,
            title: 'Deposit',
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/deposit.vue'),
        },
        {
          path: 'kodo',
          name: 'KodoPay',
          meta: {
            needLogin: true,
            title: 'KodoPay',
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/KodoPay.vue'),
        },
        {
          path: 'alchemy',
          name: 'AlchemyPay',
          meta: {
            needLogin: true,
            title: 'AlchemyPay',
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/AlchemyPay.vue'),
        },
        {
          // 充值交易记录
          path: 'transactions',
          name: 'Transactions',
          meta: {
            needLogin: true,
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/transactions.vue'),
        },
        {
          path: 'transactions/:id',
          name: 'TransactionsTopUpDetails',
          meta: {
            needLogin: true,
            isKeepAlive: false,
          },
          component: () => import('@/views/topUp/transactionsTopUpDetails.vue'),
        },
      ],
    },
    {
      path: '/massMessagesStatistics',
      name: 'MassMessagesStatistics',
      meta: {
        needLogin: true,
        title: 'Mass Messages Statistics',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/chats/massMessagesStatistics.vue'),
    },
    {
      path: '/appeal',
      name: 'Appeal',
      meta: {
        title: 'Appeal',
        isKeepAlive: true,
        key: Date.now(),
      },
      component: () => import('@/views/about/appeal.vue'),
    },
  ],
}
